import React, {useEffect, useState} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter} from 'react-router-dom'
import Authenticated from './AuthenticatedRoutes'
import UnAuthenticated from './UnAuthenticatedRoutes'
import '../assets/OverrideCSS.css'
import {useSelector} from 'react-redux'
import {IRootState} from '../State/Store'
import {getToken} from '../API/apiRequest'
import {useDispatch} from 'react-redux'
import {login} from '../State/Slice/userSlice'
import {Loading} from "../components/Loading/Loading";

const MyRoutes: React.FC = () => {
    const user = useSelector((state: IRootState) => state.user)
    const [loading, setLoading] = useState<boolean>(true)
    const dispatch = useDispatch()
    useEffect(() => {
        async function readData() {
            try {
                let jsonUser = await localStorage.getItem('user')
                if(jsonUser) {
                    let user = await JSON.parse(jsonUser)
                    if(user.refreshToken) {
                        let token = await getToken()
                        if(token) {
                            if(user.type === 'ER')
                                dispatch(login({
                                    type: 'ER',
                                    name: user.name,
                                    companyName: user.companyName,
                                    logId: user.log,
                                    picture: user.picture
                                }))
                            else if(user.type === 'EE') {
                                dispatch(login({
                                    type: 'EE',
                                    name: user.name,
                                    logId: user.log,
                                    picture: user.picture,
                                    gender: user.gender
                                }))
                            } else {
                                return
                            }
                        }
                    }
                }
            } catch(e) {
                setLoading(false)
                return
            }
            setLoading(false)
        }

        readData()
    }, [dispatch])
    if(loading)
        return <Loading/>
    return (
            <BrowserRouter>

                {
                    user.type !== null ? <Authenticated/> : <UnAuthenticated/>
                }
            </BrowserRouter>
    )
}
export default MyRoutes